// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__1vXz0","error":"Textarea_error__wHnOO"};